// useForgotPassword.ts
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";

import backendClient from "src/api";

export const useForgotPassword = () => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const handleForgotPass = (email: string) => {
    backendClient.auth
      .generatePasswordResetEmail({ email })
      .then(() => {
        enqueueSnackbar(
          "We sent you a password reset link. Please check your inbox",
          { variant: "success" }
        );
      })
      .finally(() => {
        navigate("/password-reset-confirmation-sent", {
          state: { email },
        });
      })
      .catch((error) => {
        console.error("Failed to send password reset email:", error);
        enqueueSnackbar(
          "Failed to send password reset email: " + error.message,
          { variant: "error" }
        );
      });
  };

  return handleForgotPass;
};
